export const CanvasIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={props.width ?? 33}
      height={props.height ?? 32}
      viewBox={props.viewBox ?? "0 0 33 32"}
      fill="none"
    >
      <path
        d="M16.5 0.25C7.8025 0.25 0.75 7.3025 0.75 16C0.75 24.6975 7.8025 31.75 16.5 31.75C17.9525 31.75 19.125 30.5775 19.125 29.125C19.125 28.4425 18.8625 27.83 18.4425 27.3575C18.04 26.9025 17.7775 26.29 17.7775 25.625C17.7775 24.1725 18.95 23 20.4025 23H23.5C28.33 23 32.25 19.08 32.25 14.25C32.25 6.515 25.1975 0.25 16.5 0.25ZM6.875 16C5.4225 16 4.25 14.8275 4.25 13.375C4.25 11.9225 5.4225 10.75 6.875 10.75C8.3275 10.75 9.5 11.9225 9.5 13.375C9.5 14.8275 8.3275 16 6.875 16ZM12.125 9C10.6725 9 9.5 7.8275 9.5 6.375C9.5 4.9225 10.6725 3.75 12.125 3.75C13.5775 3.75 14.75 4.9225 14.75 6.375C14.75 7.8275 13.5775 9 12.125 9ZM20.875 9C19.4225 9 18.25 7.8275 18.25 6.375C18.25 4.9225 19.4225 3.75 20.875 3.75C22.3275 3.75 23.5 4.9225 23.5 6.375C23.5 7.8275 22.3275 9 20.875 9ZM26.125 16C24.6725 16 23.5 14.8275 23.5 13.375C23.5 11.9225 24.6725 10.75 26.125 10.75C27.5775 10.75 28.75 11.9225 28.75 13.375C28.75 14.8275 27.5775 16 26.125 16Z"
        fill="#BDA1C9"
      />
    </svg>
  );
};
